<template>
    <mobile-card>
        <template slot="title">
			<div v-if="item.isLock" class="flex-column-center ">
				<van-icon name="lock" size="0.43rem"/>
				<span style="margin-left:5px;">{{item.itemName }}</span>
			</div>
            <div v-else>
                <!-- <van-checkbox :value="checked" checked-color="#005423" @click="onChange" icon-size="16px"> -->
                <van-checkbox :value="checked" checked-color="#005423" @click="onChange" icon-size="0.43rem">
                    {{item.itemName}}
                </van-checkbox>
            </div>
        </template>

        <template slot="content">
            <div class="flex-form-info">
                <div class="left">交费区间</div>
                <div class="right">{{item.intervalName}}</div>
            </div>
            <div class="flex-form-info">
                <div class="left">当前应交</div>
                <div class="right link">{{item.needMoney | formatMoney}}</div>
            </div>
            <div class="flex-form-info" v-show="hiddenEdit">
                <div class="left">本次交费</div>
                <div class="right">
                    <span>{{item.nowMoney | formatMoney}}</span>
                    <van-icon v-if="can_edit" name="edit" @click="onEdit"/>
                </div>
            </div>
            <div class="flex-form-info" v-show="!hiddenEdit">
				<div class="left">本次交费</div>
				<!-- <span :data-tootik="editMoneyPlaceholder" style="width:60%;"> -->
				<!-- <van-field class="money-input-item" v-model="item.nowMoney" clearable type="number" input-align="right"  @change="inputChange" ></van-field> -->
				<span :data-tootik="editMoneyPlaceholder">
					<vue-numeric v-model="item.nowMoney" :min="item.minMoney" :max="item.needMoney" :precision="2" class="money-input" @change="inputChange"></vue-numeric>
				</span>
            </div>
        </template>
    </mobile-card>
</template>
<script>
    import eventBus from '../../eventbus'
    import MobileCard from "components/mobile-card/index";

    export default {
        name: "chargeCard",
        components: {MobileCard},
        props: {
            item: Object,
            selectList:Array
        },
        data() {
            return {
                hiddenEdit: true,
				checked: false,
            }
		},

		computed: {
            can_edit() {
				// 20200817 允许应收分次交费，若当前应交<=最低交费，期望不允许修改本次交费金额 bug295
                return this.item.editMoney && (this.item.needMoney > this.item.minMoney)
			},	
			editMoneyPlaceholder() {
				if(this.item.minMoney) {
					return this.$t('unpaid_fee.minMoneyStart') + this.$options.filters.formatMoney(this.item.minMoney) + this.$t('choose_fee.maxMoneyEnd')
				}
			}
		},
		
        created() {
            eventBus.$on('select-all', this.selectAll)
		},
		
        methods: {
            isMutiBank() { //是否多个银行
                let isPass = true
                if(!this.checked) {
                    this.selectList.forEach((select)=>{
                        if(select.bankAccount!==this.item.bankAccount) {
                           isPass = false 
                        }
                    })
                }
                if(!isPass) {
                    this.$toast({
                        duration: 3000, // 持续展示 toast
                        forbidClick:true,
                        message: '该收费项目不能与已经选择的其他收费项目一同交费。'
                    })
                }
                return !isPass
            },
            onChange() {
                if(this.isMutiBank()) return
                this.checked = !this.checked
                eventBus.$emit('summary-price', {item: this.item, checked: this.checked})
			},
			
            inputChange(val) {
                if(val > this.item.itemMoney) {
                    val = this.item.itemMoney;
                }
                
                console.log('this is a test',val)
                if (this.checked) {
                    eventBus.$emit('summary-price', {item: this.item, checked: this.checked})
                }
			},
			
            onEdit() {
                this.hiddenEdit = false
			},
			
            selectAll(value) {
				this.checked = value
            }
        },
    }
</script>
<style lang="scss" scoped>
    // .charge-card-title {
    //     /*font-size: 16px;*/
    //     /*font-weight: bold;*/
    //     color: #005423;
    //     background: #e9e9e9;
    //     height: 6vh;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     border-radius: 5px 5px 0 0;
    // }


    // .charge-card {
    //     width: 90vw;
    //     margin: 2vh auto;
    //     background: #ffffff;
    //     border-radius: 5px;


    //     .card-info {
    //         display: flex;
    //         flex-direction: row;
    //         justify-content: space-between;
    //         // padding: 2vw 4vw;
    //         padding: 10px 16px;

    //         .left {
    //             flex: auto;
    //             text-align: left;
    //         }

    //         .right {
    //             flex: auto;
    //             text-align: right;
    //         }
    //     }
    // }

    // .input-border {
    //     /deep/ .van-field__body {
    //         border: 1px solid #005423;
    //         border-radius: 5px;
    //         padding-right: 5px;
    //         padding-left: 5px;
    //     }
    // }

    // .link {
    //     text-decoration: underline;
    //     color: #005423;
    // }

    // /deep/ .van-checkbox__icon .van-icon {
    //     border-color: #ababab;
    // }

    // /deep/ .van-checkbox__label {
    //     color: #005423;
    // }

    // /deep/ .van-field {
    //     font-size: 16px;
    // }

    // /deep/ .van-field__label {
    //     text-align: left;
    // }
</style>
